import React from 'react';
import { FiAlertTriangle, FiX, FiExternalLink, FiShield } from 'react-icons/fi';
import './LinkWarningModal.css';

/**
 * LinkWarningModal Component
 * Security warning modal shown before opening external links in DMs
 *
 * Features:
 * - Shows the full URL to the user
 * - Lists security warnings
 * - Opens links in new tab with security attributes
 * - Prevents phishing and malicious links
 */
export default function LinkWarningModal({ url, senderName, onClose, onConfirm }) {
    const handleConfirm = () => {
        // Open link in new tab with security attributes
        window.open(url, '_blank', 'noopener,noreferrer');
        onConfirm();
    };

    return (
        <div className="link-warning-overlay" onClick={onClose}>
            <div className="link-warning-modal" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="link-warning-header">
                    <div className="header-title">
                        <FiAlertTriangle className="warning-icon" />
                        <h3>External Link Warning</h3>
                    </div>
                    <button className="close-btn" onClick={onClose} aria-label="Close">
                        <FiX />
                    </button>
                </div>

                {/* Content */}
                <div className="link-warning-content">
                    <div className="link-display">
                        <FiExternalLink className="link-icon" />
                        <div className="link-info">
                            <p className="link-label">You're about to visit:</p>
                            <p className="link-url">{url}</p>
                        </div>
                    </div>

                    <div className="sender-info">
                        <p>This link was shared by <strong>{senderName}</strong></p>
                    </div>

                    <div className="security-warnings">
                        <div className="warning-header">
                            <FiShield />
                            <h4>Security Notice</h4>
                        </div>
                        <p className="warning-intro">
                            The Orbital Ledger cannot verify the safety of external websites.
                        </p>
                        <ul className="warning-list">
                            <li>
                                <span className="warning-bullet">•</span>
                                <span>Only visit links from users you trust</span>
                            </li>
                            <li>
                                <span className="warning-bullet">•</span>
                                <span>Never enter your login credentials on suspicious sites</span>
                            </li>
                            <li>
                                <span className="warning-bullet">•</span>
                                <span>Be cautious of phishing attempts and scams</span>
                            </li>
                            <li>
                                <span className="warning-bullet">•</span>
                                <span>Verify the URL matches the intended destination</span>
                            </li>
                            <li>
                                <span className="warning-bullet">•</span>
                                <span>Report suspicious links to moderators</span>
                            </li>
                        </ul>
                    </div>

                    <div className="security-footer">
                        <FiShield className="shield-icon" />
                        <p>This link will open in a new tab for your protection</p>
                    </div>
                </div>

                {/* Actions */}
                <div className="link-warning-actions">
                    <button className="btn-cancel" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="btn-open-link" onClick={handleConfirm}>
                        <FiExternalLink />
                        Open Link (New Tab)
                    </button>
                </div>
            </div>
        </div>
    );
}
